"use strict";

var _interopRequireDefault = require("/home/zklink/web/zklink-explorer-web-build/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/home/zklink/web/zklink-explorer-web-build/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
var _defineProperty2 = _interopRequireDefault(require("/home/zklink/web/zklink-explorer-web-build/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/zklink/web/zklink-explorer-web-build/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _utils = require("@/utils");
var _config = require("@/config");
var _api = require("@/api");
var _networkUtilsMixin = _interopRequireDefault(require("@/constants/networkUtilsMixin"));
var _Tip = _interopRequireDefault(require("@/components/Tip"));
var _Link = _interopRequireDefault(require("@/components/Link"));
var _Status2 = _interopRequireDefault(require("@/components/Status"));
var _CopyToClipboard = _interopRequireDefault(require("@/components/CopyToClipboard"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _default = {
  name: 'ComplexTable',
  components: {
    CopyToClipboard: _CopyToClipboard.default,
    Tip: _Tip.default,
    Link: _Link.default,
    Status: _Status2.default
  },
  directives: {},
  filters: {},
  mixins: [_networkUtilsMixin.default],
  data: function data() {
    return {
      detailInfo: {
        tx: {},
        detail: {},
        detailData: {}
      },
      count: 90,
      timer: null,
      isTransactionReceipt: false
    };
  },
  computed: {},
  mounted: function mounted() {
    this.contractIdListGet();
  },
  methods: {
    linkDetail: function linkDetail(path) {
      this.$router.push(path);
    },
    contractIdListGet: function contractIdListGet() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var hash, res, timeCount;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              hash = _this.$route.params.hash;
              _context2.next = 4;
              return (0, _api.transactionsDetailApi)([{
                txnHash: hash
              }]);
            case 4:
              res = _context2.sent;
              if (!res.error || !res.result) {
                _this.detailInfo = _objectSpread({}, res.result);
              }
              timeCount = 90;
              if ((!!res.error || !res.result) && !_this.timer) {
                _this.count = timeCount;
                _this.timer = setInterval( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (!(_this.count > 0 && _this.count <= timeCount)) {
                          _context.next = 4;
                          break;
                        }
                        _this.count--;
                        _context.next = 8;
                        break;
                      case 4:
                        clearInterval(_this.timer);
                        _this.timer = null;
                        _context.next = 8;
                        return _this.contractIdListGet();
                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                })), 1000);
              }
              _context2.next = 13;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0, 'error');
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 10]]);
      }))();
    },
    typeName: function typeName(value) {
      var d = _.find(_config.TRANSACTION_TYPE, {
        value: value
      });
      return d ? d.label : '';
    },
    linkHash: function linkHash(info) {},
    blockHeightDetail: function blockHeightDetail(info) {
      if (info.status === 1 || info.status === 4) {
        return null;
      } else {
        this.$router.push("/block/".concat(info.blockHeight));
      }
    },
    linkTokens: function linkTokens(token) {
      this.linkDetail("/tokens/".concat(token.id));
    },
    accountDetail: function accountDetail(value) {
      this.$router.push("/address/".concat(value));
    },
    getOrderMatching: function getOrderMatching(viewMap, viewList) {
      var h = this.$createElement;
      var list = ['OrderMatchingH', 'Sell', 'Buy', 'OrderMatchingF'];
      return h("div", [_.map(list, function (n) {
        return h("div", {
          "class": 'detailInfo',
          "style": 'marginBottom:20px'
        }, [h("table", [h("tbody", [_.map(viewList[n], function (n, i) {
          return viewMap[n]();
        })])])]);
      })]);
    },
    orderMatchingAmount: function orderMatchingAmount(info) {
      var h = this.$createElement;
      var data = info.amount;
      return h("tr", [h("td", ["Amount:"]), h("td", [h("div", {
        "class": 'tokenSwap'
      }, [h("div", {
        "style": 'display: flex'
      }, [h("span", {
        "class": 'tokenText'
      }, [(0, _utils.paddingNum)(data[0].value, 18)]), h("span", {
        "class": 'iconInline',
        "style": {
          backgroundImage: "url(".concat((0, _utils.getTokenIcon)(data[0].symbol), ")")
        }
      }), h("span", {
        "class": 'tokenText'
      }, [data[0].symbol])]), h("span", {
        "class": 'directIcon arrow'
      }), h("div", {
        "style": 'display: flex'
      }, [h("span", {
        "class": 'tokenText'
      }, [(0, _utils.paddingNum)(data[1].value, 18)]), h("span", {
        "class": 'iconInline',
        "style": {
          backgroundImage: "url(".concat((0, _utils.getTokenIcon)(data[1].symbol), ")")
        }
      }), h("span", {
        "class": 'tokenText'
      }, [data[1].symbol])])])])]);
    },
    orderMatchingReceived: function orderMatchingReceived(info) {
      var h = this.$createElement;
      var data = info.received;
      return h("tr", [h("td", ["Received:"]), h("td", [h("div", {
        "class": 'iconList'
      }, [h("span", [(0, _utils.paddingNum)(data.value, 18)]), h("div", {
        "class": 'iconLi iconLi3',
        "style": {
          backgroundImage: "url(".concat((0, _utils.getTokenIcon)(data.symbol), ")")
        }
      }), h("span", [data.symbol])])])]);
    },
    orderMatchingTradeFee: function orderMatchingTradeFee(info) {
      var h = this.$createElement;
      var data = info.trade_fee;
      return h("tr", [h("td", [h(_Tip.default, {
        "attrs": {
          "placement": 'right'
        }
      }, [h("span", ["Trade Fee is set within a range of [0, 2.55%].", h("br"), "The exact fee is determined by a value confirmed ", h("br"), "through the user's signature."])]), " Trade Fee:"]), h("td", [h("div", {
        "class": 'iconList'
      }, [h("span", [(0, _utils.paddingNum)(data.value, 18)]), h("div", {
        "class": 'iconLi iconLi3',
        "style": {
          backgroundImage: "url(".concat((0, _utils.getTokenIcon)(data.symbol), ")")
        }
      }), h("span", [data.symbol])])])]);
    },
    orderMatchingRole: function orderMatchingRole(info) {
      var h = this.$createElement;
      return h("td", [this.modelGet('app.device') !== 'desktop' ? null : h("span", {
        "class": 'fromWrap'
      }, [info.account.level]), h(_Link.default, {
        "attrs": {
          "href": info.account.level === 'L1' ? this.l1ExploreAddress(info.account.value, info.account.hash) : "/address/".concat(info.account.hash),
          "isBlank": info.account.level === 'L1',
          "text": (0, _utils.erc20Address)(info.account.hash)
        }
      }), h(_CopyToClipboard.default, {
        "attrs": {
          "textToCopy": (0, _utils.erc20Address)(info.account.hash),
          "content": 'Copy Account'
        }
      }), h("svg-icon", {
        "attrs": {
          "icon-class": 'Jump-icon'
        }
      }), this.modelGet('app.device') === 'desktop' ? null : h("span", {
        "class": 'fromWrap'
      }, [info.account.level]), h("span", {
        "class": this.iconInfo(info.account).style
      }, [this.iconInfo(info.account).name])]);
    },
    orderMatchingNonce: function orderMatchingNonce(info) {
      var h = this.$createElement;
      return h("tr", [h("td", [h(_Tip.default, {
        "attrs": {
          "placement": 'right'
        }
      }, [h("span", ["The nonce is used specifically within the zkLink platform. ", h("br"), "It is unrelated to the nonce values of other layer1s or layer2s."])]), " Nonce:"]), h("td", [info.nonce])]);
    }
  },
  render: function render() {
    var _this2 = this;
    var h = arguments[0];
    var info = this.detailInfo;
    var viewMap = {
      'Tx': function Tx() {
        return h("tr", [h("td", [h(_Tip.default, {
          "attrs": {
            "placement": 'right'
          }
        }, [h("span", ["A TxHash or transaction hash is a unique", h("br"), "66-character identifier that is generated", h("br"), "whenever a transaction is executed.", h("br"), "This particular TxHash corresponds ", h("br"), "to a transaction executed on the zkLink.", h("br")])]), " Transaction Hash:"]), h("td", [info.txnHash, h(_CopyToClipboard.default, {
          "attrs": {
            "textToCopy": info.txnHash,
            "copied": 'handleCopy'
          }
        })])]);
      },
      'L1Hash': function L1Hash() {
        return h("tr", [h("td", [h(_Tip.default, {
          "attrs": {
            "placement": 'right'
          }
        }, [h("span", ["Hash of the actual deposit transaction on ", h("br"), "the relevant chain. L1 here refers to Layer1s ", h("br"), "and Layer2s supported by zkLink."])]), " L1 Deposit Hash:"]), h("td", [h(_Link.default, {
          "attrs": {
            "href": _this2.l1ExploreTxUrl(info.l1Hash.chain_id, info.l1Hash.l1_hash),
            "text": info.l1Hash.l1_hash
          }
        }), h(_CopyToClipboard.default, {
          "attrs": {
            "textToCopy": info.l1Hash.l1_hash,
            "copied": 'handleCopy'
          }
        }), h("svg-icon", {
          "attrs": {
            "icon-class": 'Jump-icon'
          }
        }), h("span", {
          "class": _this2.findNetwork(info.l1Hash.chain_id).style
        }, [_this2.findNetwork(info.l1Hash.chain_id).name])])]);
      },
      'Transaction': function Transaction() {
        return h("tr", [h("td", ["Transaction ID:"]), h("td", [info.txHash])]);
      },
      'Type': function Type() {
        return h("tr", [h("td", [h(_Tip.default, {
          "attrs": {
            "placement": 'right'
          }
        }, [h("span", ["The type of the transaction."])]), " Type:"]), h("td", [h("span", [_this2.typeName(info.opType)]), info.fastWithdraw ? h("span", {
          "class": 'chain-icon fast-color'
        }, ["fast"]) : ''])]);
      },
      'Pair': function Pair() {
        return h("tr", [h("td", [h(_Tip.default, {
          "attrs": {
            "placement": 'right'
          }
        }, [h("span", ["Specifically refers to the taker and maker", h("br"), "tokens in the OrderMatching"])]), " Trading Pair:"]), h("td", [h("div", {
          "class": 'iconList'
        }, [h("div", {
          "class": 'iconLi iconLi4',
          "style": {
            backgroundImage: "url(".concat((0, _utils.getTokenIcon)(info.extend.pair[0].symbol), ")")
          }
        }), h("div", {
          "class": 'iconLi iconLi4',
          "style": {
            backgroundImage: "url(".concat((0, _utils.getTokenIcon)(info.extend.pair[1].symbol), ")")
          }
        }), h("span", ["".concat(info.extend.pair[0].symbol, "/").concat(info.extend.pair[1].symbol)])])])]);
      },
      'From': function From() {
        return h("tr", [h("td", [h(_Tip.default, {
          "attrs": {
            "placement": 'right'
          }
        }, [h("span", ["The sending party of the transaction."])]), " From:"]), h("td", [_this2.modelGet('app.device') !== 'desktop' ? null : h("span", {
          "class": 'fromWrap'
        }, [info.from.level]), h(_Link.default, {
          "attrs": {
            "href": info.from.level === 'L1' ? _this2.l1ExploreAddress(info.from.value, info.from.hash) : "/address/".concat(info.from.hash),
            "isBlank": info.from.level === 'L1',
            "text": (0, _utils.erc20Address)(info.from.hash)
          }
        }), h(_CopyToClipboard.default, {
          "attrs": {
            "textToCopy": (0, _utils.erc20Address)(info.from.hash),
            "content": 'Copy Address'
          }
        }), info.from.level === 'L1' ? h(_Tip.default, {
          "attrs": {
            "placement": 'top',
            "isJumpTip": true
          }
        }, [h("span", ["Click to visit ", _this2.iconInfo(info.from).name, " explore"])]) : h("svg-icon", {
          "attrs": {
            "icon-class": 'Jump-icon'
          }
        }), _this2.modelGet('app.device') === 'desktop' ? null : h("span", {
          "class": 'fromWrap'
        }, [info.from.level]), h("span", {
          "class": _this2.iconInfo(info.from).style
        }, [_this2.iconInfo(info.from).name])])]);
      },
      'To': function To() {
        return h("tr", [h("td", [h(_Tip.default, {
          "attrs": {
            "placement": 'right'
          }
        }, [h("span", ["The receiving party of the transaction", h("br"), "(could be a contract address)."])]), " To:"]), h("td", [_this2.modelGet('app.device') !== 'desktop' ? null : h("span", {
          "class": 'fromWrap'
        }, [info.to.level]), h(_Link.default, {
          "attrs": {
            "href": info.to.level === 'L1' ? _this2.l1ExploreAddress(info.to.value, info.to.hash) : "/address/".concat(info.to.hash),
            "isBlank": info.to.level === 'L1',
            "text": (0, _utils.erc20Address)(info.to.hash)
          }
        }), h(_CopyToClipboard.default, {
          "attrs": {
            "textToCopy": (0, _utils.erc20Address)(info.to.hash),
            "content": 'Copy Address'
          }
        }), info.to.level === 'L1' ? h(_Tip.default, {
          "attrs": {
            "placement": 'top',
            "isJumpTip": true
          }
        }, [h("span", ["Click to visit ", _this2.iconInfo(info.to).name, " explore"])]) : h("svg-icon", {
          "attrs": {
            "icon-class": 'Jump-icon'
          }
        }), _this2.modelGet('app.device') === 'desktop' ? null : h("span", {
          "class": 'fromWrap'
        }, [info.to.level]), h("span", {
          "class": _this2.iconInfo(info.to).style
        }, [_this2.iconInfo(info.to).name])])]);
      },
      'Amount': function Amount() {
        return h("tr", [h("td", ["Amount:"]), h("td", [h("div", {
          "class": 'iconList'
        }, [h("span", [(0, _utils.paddingNum)(info.amount.value, 18)]), h("div", {
          "class": 'iconLi iconLi3',
          "style": {
            backgroundImage: "url(".concat((0, _utils.getTokenIcon)(info.amount.symbol), ")")
          }
        }), h("span", {
          "style": 'margin-right:4px'
        }, [info.amount.symbol]), " ($", (0, _utils.paddingNum)(info.totalValue), ")"])])]);
      },
      'Received': function Received() {
        return h("tr", [h("td", [h(_Tip.default, {
          "attrs": {
            "placement": 'right'
          }
        }, [h("span", ["This is the minimum amount you might receive because a", h("br"), "fast withdrawal could fail and automatically revert to a", h("br"), "standard withdrawal. In such a case, you will receive funds", h("br"), "identical to what the 'amount' field displays."])]), " Received:"]), h("td", [h("div", {
          "class": 'iconList'
        }, [h("span", [(0, _utils.paddingNum)(info.received.value, 18)]), h("div", {
          "class": 'iconLi iconLi3',
          "style": {
            backgroundImage: "url(".concat((0, _utils.getTokenIcon)(info.received.symbol), ")")
          }
        }), h("span", [info.received.symbol])])])]);
      },
      // withdraw
      'Fee': function Fee() {
        return h("tr", [h("td", [h(_Tip.default, {
          "attrs": {
            "placement": 'right'
          }
        }, [h("span", ["This field represents the zkLink layer2", h("br"), "fee and is not included in the 'amount'."])]), " Fee:"]), h("td", [h("div", {
          "class": 'iconList'
        }, [h("span", [(0, _utils.paddingNum)(info.fee.value, 18)]), h("div", {
          "class": 'iconLi iconLi3',
          "style": {
            backgroundImage: "url(".concat((0, _utils.getTokenIcon)(info.fee.symbol), ")")
          }
        }), h("span", [info.fee.symbol])])])]);
      },
      'BrokerHash': function BrokerHash() {
        return h("tr", [h("td", [h(_Tip.default, {
          "attrs": {
            "placement": 'right'
          }
        }, [h("span", ["The actual payment transaction occurs in this hash."])]), " Actual withdrawal hash:"]), info.brokerHash ? h("td", [h(_Link.default, {
          "attrs": {
            "href": _this2.l1ExploreTxUrl(info.to.value, info.brokerHash),
            "text": info.brokerHash
          }
        }), h(_CopyToClipboard.default, {
          "attrs": {
            "textToCopy": info.brokerHash,
            "copied": 'handleCopy'
          }
        }), h("svg-icon", {
          "attrs": {
            "icon-class": 'Jump-icon'
          }
        }), h("span", {
          "class": _this2.iconInfo(info.to).style
        }, [_this2.iconInfo(info.to).name])]) : h("td", ["--"])]);
      },
      'BrokerFee': function BrokerFee() {
        return h("tr", [h("td", [h(_Tip.default, {
          "attrs": {
            "placement": 'right'
          }
        }, [h("span", ["This fee is paid to the broker for fast withdrawals."])]), " Broker Fee:"]), h("td", [info.fastWithdraw ? h("div", {
          "class": 'iconList'
        }, [h("span", [(0, _utils.paddingNum)(info.brokerFee.value, 18)]), h("div", {
          "class": 'iconLi iconLi3',
          "style": {
            backgroundImage: "url(".concat((0, _utils.getTokenIcon)(info.brokerFee.symbol), ")")
          }
        }), h("span", [info.brokerFee.symbol])]) : '--'])]);
      },
      // OrderMatching
      'Sell': function Sell() {
        return h("tr", {
          "style": 'fontWeight:700'
        }, [h("td", ["Maker"])]);
      },
      'Buy': function Buy() {
        return h("tr", {
          "style": 'fontWeight:700'
        }, [h("td", ["Taker"])]);
      },
      'Taker': function Taker() {
        return h("tr", [h("td", ["Account:"]), _this2.orderMatchingRole(info.extend.sell)]);
      },
      'Maker': function Maker() {
        return h("tr", [h("td", ["Account:"]), _this2.orderMatchingRole(info.extend.buy)]);
      },
      'AmountTaker': function AmountTaker() {
        return _this2.orderMatchingAmount(info.extend.sell);
      },
      'AmountMaker': function AmountMaker() {
        return _this2.orderMatchingAmount(info.extend.buy);
      },
      'ReceivedTaker': function ReceivedTaker() {
        return _this2.orderMatchingReceived(info.extend.sell);
      },
      'ReceivedMaker': function ReceivedMaker() {
        return _this2.orderMatchingReceived(info.extend.buy);
      },
      'TradeFeeTaker': function TradeFeeTaker() {
        return _this2.orderMatchingTradeFee(info.extend.sell);
      },
      'TradeFeeMaker': function TradeFeeMaker() {
        return _this2.orderMatchingTradeFee(info.extend.buy);
      },
      'NonceTaker': function NonceTaker() {
        return _this2.orderMatchingNonce(info.extend.sell);
      },
      'NonceMaker': function NonceMaker() {
        return _this2.orderMatchingNonce(info.extend.buy);
      },
      'TotalValue': function TotalValue() {
        return h("tr", [h("td", ["Total Value:"]), h("td", ["$", (0, _utils.paddingNum)(info.totalValue)])]);
      },
      'Status': function Status() {
        return h("tr", [h("td", [h(_Tip.default, {
          "attrs": {
            "placement": 'right'
          }
        }, [h("span", ["The status of the transaction."])]), " Status:"]), h("td", [h(_Status2.default, {
          "attrs": {
            "status": info.status
          }
        })])]);
      },
      'BlockHeight': function BlockHeight() {
        return h("tr", [h("td", [h(_Tip.default, {
          "attrs": {
            "placement": 'right'
          }
        }, [h("span", ["zkLink layer2 block height."])]), " Block Height:"]), h("td", [info.blockHeight ? h(_Link.default, {
          "attrs": {
            "href": "/block/".concat(info.blockHeight),
            "isBlank": false,
            "text": info.blockHeight
          }
        }) : '--'])]);
      },
      // withdraw
      'Nonce': function Nonce() {
        return h("tr", [h("td", [h(_Tip.default, {
          "attrs": {
            "placement": 'right'
          }
        }, [h("span", ["The nonce is used specifically within the zkLink platform. ", h("br"), "It is unrelated to the nonce values of other layer1s or layer2s."])]), " Nonce:"]), h("td", [info.nonce])]);
      },
      // Changepubkey
      'Account': function Account() {
        return h("tr", [h("td", ["Account:"]), h("td", [h(_Link.default, {
          "attrs": {
            "href": "/address/".concat(info.account),
            "isBlank": false,
            "text": info.account
          }
        }), h(_CopyToClipboard.default, {
          "attrs": {
            "textToCopy": info.account,
            "copied": 'handleCopy'
          }
        })])]);
      },
      'CreatedAt': function CreatedAt() {
        return h("tr", [h("td", ["Created at:"]), h("td", [(0, _utils.dayFormat)(info.created)])]);
      },
      'L2CompeletedAt': function L2CompeletedAt() {
        return h("tr", [h("td", ["L2 Executed at:"]), h("td", [h("svg-icon", {
          "attrs": {
            "icon-class": 'clock-icon'
          }
        }), (0, _utils.customFormatUTC)(info.l2Completed), " (", (0, _utils.dayFormatUTC)(info.l2Completed), ")"])]);
      },
      'L1CompeletedAt': function L1CompeletedAt() {
        return h("tr", [h("td", ["L1 Compeleted at:"]), h("td", [(0, _utils.dayFormat)(info.l1Completed)])]);
      }
    };
    var viewList = {
      // Deposit
      'Deposit': ['Tx', 'L1Hash', 'Type', 'Status', 'From', 'To', 'Amount', 'Received', 'BlockHeight', 'L2CompeletedAt'],
      // Withdraw
      'Withdraw': ['Tx', 'Type', 'Status', 'From', 'To', 'Amount', 'Received', 'Fee', 'BrokerHash'].concat((0, _toConsumableArray2.default)(info.brokerHash && info.fastWithdraw ? ['BrokerFee'] : []), ['BlockHeight', 'Nonce', 'L2CompeletedAt']),
      // Transfer
      'Transfer': ['Tx', 'Type', 'Status', 'From', 'To', 'Amount', 'Received', 'Fee', 'BlockHeight', 'Nonce', 'L2CompeletedAt'],
      // ChangePubKey
      'ChangePubKey': ['Tx', 'Type', 'Status', 'Fee', 'BlockHeight', 'Nonce', 'Account', 'L2CompeletedAt'],
      // ForcedExit
      'ForcedExit': ['Tx', 'Type', 'Status', 'From', 'To', 'Amount', 'Received', 'BrokerHash', 'BlockHeight', 'Nonce', 'L2CompeletedAt'],
      // FullExit
      'FullExit': ['Tx', 'L1Hash', 'Type', 'Status', 'From', 'To', 'Amount', 'Received', 'BlockHeight', 'L2CompeletedAt']
    }[this.typeName(info.opType)];
    var OrderMatchingList = {
      'OrderMatchingH': ['Tx', 'Type', 'Status', 'Pair'],
      'Sell': ['Sell', 'Taker', 'AmountTaker', 'ReceivedTaker', 'TradeFeeTaker', 'NonceTaker'],
      'Buy': ['Buy', 'Maker', 'AmountMaker', 'ReceivedMaker', 'TradeFeeMaker', 'NonceMaker'],
      'OrderMatchingF': ['TotalValue', 'BlockHeight', 'L2CompeletedAt']
    };
    if (info.failReason != null) {
      viewList.push('Error Details');
    }
    return h("div", {
      "class": 'app-container'
    }, [h("div", {
      "class": 'app-header'
    }, ["Transactions Details"]), h("div", {
      "class": 'detailInfo'
    }, [!info.opType && h("div", {
      "class": 'goHome',
      "on": {
        "click": this.contractIdListGet
      }
    }, ["Data loading... Click to refresh ", h("span", {
      "style": 'color:red'
    }, ["(~", this.count, "s)"]), " "]), this.typeName(info.opType) !== 'OrderMatching' ? h("table", [h("tbody", [_.map(viewList, function (n, i) {
      return viewMap[n]();
    })])]) : null]), this.typeName(info.opType) === 'OrderMatching' ? this.getOrderMatching(viewMap, OrderMatchingList) : null]);
  }
};
exports.default = _default;